import { makeAutoObservable, runInAction } from "mobx";

import { deleteMembership, updateMembership, type Membership } from "@/api";

export type MemberRole = "member" | "admin" | "owner";
// | "guest"; We do not support it for now

export class MemberApi {
  memberData: Membership;

  constructor(memberData: Membership) {
    this.memberData = memberData;
    makeAutoObservable(this);
  }

  async updateRole(role: MemberRole) {
    const { membership } = await updateMembership(this.memberData.id, {
      accessLevel: role,
    });
    runInAction(() => {
      this.memberData = membership ?? { ...this.memberData, accessLevel: role };
    });
    return { membership };
  }

  async remove() {
    return deleteMembership(this.memberData.id);
  }
}
